// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonComponent_button__3C01A","buttonContent":"ButtonComponent_buttonContent__1lVZc","left":"ButtonComponent_left__3AwOo","right":"ButtonComponent_right__207oW"};